import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router';
import './App.css';
import Login from './pages/Login';
import Chat from './pages/Chat';
import PublicRoutes from './routes/PublicRoutes';
import PrivateRoutes from './routes/PrivateRoutes';
import { SidebarProvider } from './context/SidebasContext';
import { ModuleProvider } from './context/ModuleContext';
import { ChatHeadersProvider } from './context/ChatHeadersContext';
import NotFoundPage from './pages/NotFound';
import { useEffect } from 'react';
import { performTokenMigration } from './utils/tokenMigration';
import UsageAnalytics from './pages/Usage';

function App() {
  // Perform token migration on app startup
  useEffect(() => {
    performTokenMigration();
  }, []);

  return (
    <Router>
      <ModuleProvider>
        <SidebarProvider>
          <ChatHeadersProvider>
            <Routes>
              <Route element={<PublicRoutes />}>
                <Route path='/' element={<Navigate to='/login' />} />
                <Route path='/login' element={<Login />} />
              </Route>
              <Route element={<PrivateRoutes />}>
                <Route path='/chat' element={<Chat />} />
                <Route path='/chat/:id' element={<Chat />} />
                <Route path='/usage' element={<UsageAnalytics />} />
                <Route path='*' element={<NotFoundPage />} />
              </Route>
            </Routes>
          </ChatHeadersProvider>
        </SidebarProvider>
      </ModuleProvider>
    </Router>
  );
}

export default App;
